// extracted by mini-css-extract-plugin
module.exports = {"contCarousel":"Sponsors_contCarousel__K-CaG","carousel":"Sponsors_carousel__1Cz8l","contImage":"Sponsors_contImage__33G0O","image":"Sponsors_image__oC5h3"};